export const Waiting = () => {
  return (
    <div className="modal-backdrop show">
      <div
        className={'min-vh-70 d-flex justify-content-center align-items-center'}
      >
        <div
          className="spinner-border text-white"
          style={{
            width: '4rem',
            height: '4rem',
            border: '0.50em solid #4c00d0',
            borderRightColor: 'transparent',
          }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  );
};
